import AreaCodeLookupES from "../lookup/AreaCodeLookup/AreaCodeLookupES";
import AreaCodeLookupTR from "../lookup/AreaCodeLookup/AreaCodeLookupTR";
import AreaCodeLookupEN from "../lookup/AreaCodeLookup/AreaCodeLookupEN";
import AreaCodeLookupDE from "../lookup/AreaCodeLookup/AreaCodeLookupDE";
import AreaCodeLookupFR from "../lookup/AreaCodeLookup/AreaCodeLookupFR";
import AreaCodeLookupRU from "../lookup/AreaCodeLookup/AreaCodeLookupRU";

export const getPackageName = (i18n, value) => {
    let lang = i18n.language.toLowerCase();

    if (value.packageNames === undefined || value.packageNames === null || value.packageNames?.length === 0) {
        if (/tr/.test(lang)) return value.name_tr;
        if (/en/.test(lang)) return value.name_en;
        return value.name_en;
    }

    let packageNameTR = value.packageNames.filter(item => item.locale === 'TR')[0]?.text;
    let packageNameEN = value.packageNames.filter(item => item.locale === 'EN')[0]?.text;
    let packageNameRU = value.packageNames.filter(item => item.locale === 'RU')[0]?.text;
    let packageNameFR = value.packageNames.filter(item => item.locale === 'FR')[0]?.text;
    let packageNameDE = value.packageNames.filter(item => item.locale === 'DE')[0]?.text;
    let packageNameES = value.packageNames.filter(item => item.locale === 'ES')[0]?.text;

    if (/tr/.test(lang)) return packageNameTR;
    if (/en/.test(lang)) return packageNameEN;
    if (/ru/.test(lang)) return packageNameRU;
    if (/fr/.test(lang)) return packageNameFR;
    if (/de/.test(lang)) return packageNameDE;
    if (/es/.test(lang)) return packageNameES;
}

export const getPackageDescription = (i18n, value) => {
    let lang = i18n.language.toLowerCase();

    if (value.packageDescriptions === undefined || value.packageDescriptions === null || value.packageDescriptions?.length === 0) {
        if (/tr/.test(lang)) return value.description_tr;
        if (/en/.test(lang)) return value.description_en;
        return value.description_en;
    }

    let packageDescriptionTR = value.packageDescriptions.filter(item => item.locale === 'TR')[0]?.text;
    let packageDescriptionEN = value.packageDescriptions.filter(item => item.locale === 'EN')[0]?.text;
    let packageDescriptionRU = value.packageDescriptions.filter(item => item.locale === 'RU')[0]?.text;
    let packageDescriptionFR = value.packageDescriptions.filter(item => item.locale === 'FR')[0]?.text;
    let packageDescriptionDE = value.packageDescriptions.filter(item => item.locale === 'DE')[0]?.text;
    let packageDescriptionES = value.packageDescriptions.filter(item => item.locale === 'ES')[0]?.text;

    if (/tr/.test(lang)) return packageDescriptionTR;
    if (/en/.test(lang)) return packageDescriptionEN;
    if (/ru/.test(lang)) return packageDescriptionRU;
    if (/fr/.test(lang)) return packageDescriptionFR;
    if (/de/.test(lang)) return packageDescriptionDE;
    if (/es/.test(lang)) return packageDescriptionES;
}

export const getPackageInfo = (i18n, value) => {
    let lang = i18n.language.toLowerCase();

    if (value.packageInfos === undefined || value.packageInfos === null || value.packageInfos?.length === 0) {
        if (/tr/.test(lang)) return value.info_tr;
        if (/en/.test(lang)) return value.info_en;
        return value.info_en;
    }

    let packageInfoTR = value.packageInfos.filter(item => item.locale === 'TR')[0]?.text;
    let packageInfoEN = value.packageInfos.filter(item => item.locale === 'EN')[0]?.text;
    let packageInfoRU = value.packageInfos.filter(item => item.locale === 'RU')[0]?.text;
    let packageInfoFR = value.packageInfos.filter(item => item.locale === 'FR')[0]?.text;
    let packageInfoDE = value.packageInfos.filter(item => item.locale === 'DE')[0]?.text;
    let packageInfoES = value.packageInfos.filter(item => item.locale === 'ES')[0]?.text;

    if (/tr/.test(lang)) return packageInfoTR;
    if (/en/.test(lang)) return packageInfoEN;
    if (/ru/.test(lang)) return packageInfoRU;
    if (/fr/.test(lang)) return packageInfoFR;
    if (/de/.test(lang)) return packageInfoDE;
    if (/es/.test(lang)) return packageInfoES;
}

export const getPackageInfoDesc = (i18n, value) => {
    let lang = i18n.language.toLowerCase();

    if (value.packageInfoDescs === undefined || value.packageInfoDescs === null || value.packageInfoDescs?.length === 0) {
        if (/tr/.test(lang)) return value.info_desc_tr;
        if (/en/.test(lang)) return value.info_desc_en;
        return value.info_desc_en;
    }

    let packageInfoDescTR = value.packageInfoDescs.filter(item => item.locale === 'TR')[0]?.text;
    let packageInfoDescEN = value.packageInfoDescs.filter(item => item.locale === 'EN')[0]?.text;
    let packageInfoDescRU = value.packageInfoDescs.filter(item => item.locale === 'RU')[0]?.text;
    let packageInfoDescFR = value.packageInfoDescs.filter(item => item.locale === 'FR')[0]?.text;
    let packageInfoDescDE = value.packageInfoDescs.filter(item => item.locale === 'DE')[0]?.text;
    let packageInfoDescES = value.packageInfoDescs.filter(item => item.locale === 'ES')[0]?.text;

    if (/tr/.test(lang)) return packageInfoDescTR;
    if (/en/.test(lang)) return packageInfoDescEN;
    if (/ru/.test(lang)) return packageInfoDescRU;
    if (/fr/.test(lang)) return packageInfoDescFR;
    if (/de/.test(lang)) return packageInfoDescDE;
    if (/es/.test(lang)) return packageInfoDescES;
}

export const getAreaCodeLookup = (i18n) => {
    let lang = i18n.language.toLowerCase();
    if (/tr/.test(lang)) return AreaCodeLookupTR;
    if (/en/.test(lang)) return AreaCodeLookupEN;
    if (/ru/.test(lang)) return AreaCodeLookupRU;
    if (/fr/.test(lang)) return AreaCodeLookupFR;
    if (/de/.test(lang)) return AreaCodeLookupDE;
    if (/es/.test(lang)) return AreaCodeLookupES;
}

export const getFeedbackLink = (i18n) => {
    let lang = i18n.language.toLowerCase();
    if (/tr/.test(lang)) return "https://feedback.turkishairlines.com/tr";
    if (/en/.test(lang)) return "https://feedback.turkishairlines.com/en";
    if (/ru/.test(lang)) return "https://feedback.turkishairlines.com/ru";
    if (/fr/.test(lang)) return "https://feedback.turkishairlines.com/fr";
    if (/de/.test(lang)) return "https://feedback.turkishairlines.com/de";
    if (/es/.test(lang)) return "https://feedback.turkishairlines.com/es";
    return "https://feedback.turkishairlines.com/en";
}

export const getDistanceSalesDescriptionDomesticORInternational = (isDomestic, i18n) => {
    let lang = i18n.language.toLowerCase();
    if (isDomestic) {
        if (/tr/.test(lang)) return "Yurt içi";
        return "Domestic";
    } else {
        if (/tr/.test(lang)) return "Yurt dışı";
        return "International";
    }
}

export const getMilesAndSmilesRegisterRightsMilesLink = (i18n) => {
    let lang = i18n.language.toLowerCase();
    if (/tr/.test(lang)) return "https://www.turkishairlines.com/tr-tr/miles-and-smiles/kurallar-ve-kosullar/index.html";
    if (/en/.test(lang)) return "https://www.turkishairlines.com/en-us/miles-and-smiles/terms-and-conditions/index.html";
    if (/ru/.test(lang)) return "https://www.turkishairlines.com/ru-ru/miles-and-smiles/terms-and-conditions/index.html";
    if (/fr/.test(lang)) return "https://www.turkishairlines.com/fr-fr/miles-and-smiles/terms-and-conditions/index.html";
    if (/de/.test(lang)) return "https://www.turkishairlines.com/de-de/miles-and-smiles/terms-and-conditions/index.html";
    if (/es/.test(lang)) return "https://www.turkishairlines.com/es-es/miles-and-smiles/terms-and-conditions/index.html";
    return "https://www.turkishairlines.com/en-us/miles-and-smiles/terms-and-conditions/index.html";
}

export const getMilesAndSmilesRegisterRightsTurkishAirlinesLink = (i18n) => {
    let lang = i18n.language.toLowerCase();
    if (/tr/.test(lang)) return "https://www.turkishairlines.com/tr-tr/miles-and-smiles/program-ortaklari/index.html";
    if (/en/.test(lang)) return "https://www.turkishairlines.com/en-us/miles-and-smiles/program-partners/index.html";
    if (/ru/.test(lang)) return "https://www.turkishairlines.com/ru-ru/miles-and-smiles/program-partners/index.html";
    if (/fr/.test(lang)) return "https://www.turkishairlines.com/fr-fr/miles-and-smiles/program-partners/index.html";
    if (/de/.test(lang)) return "https://www.turkishairlines.com/de-de/miles-and-smiles/program-partners/index.html";
    if (/es/.test(lang)) return "https://www.turkishairlines.com/es-es/miles-and-smiles/program-partners/index.html";
    return "https://www.turkishairlines.com/en-us/miles-and-smiles/program-partners/index.html";
}

export const getMilesAndSmilesRegisterRightsGDPRLink = (i18n) => {
    let lang = i18n.language.toLowerCase();
    if (/tr/.test(lang)) return "https://www.turkishairlines.com/tr-tr/miles-and-smiles/kurallar-ve-kosullar/miles-smiles-programi-veri-koruma-aydinlatma-metni";
    if (/en/.test(lang)) return "https://www.turkishairlines.com/en-us/miles-and-smiles/terms-and-conditions/privacy-notice-for-miles-and-smiles/index.html";
    if (/ru/.test(lang)) return "https://www.turkishairlines.com/ru-ru/miles-and-smiles/terms-and-conditions/privacy-notice-for-miles-and-smiles/index.html";
    if (/fr/.test(lang)) return "https://www.turkishairlines.com/fr-fr/miles-and-smiles/terms-and-conditions/privacy-notice-for-miles-and-smiles/index.html";
    if (/de/.test(lang)) return "https://www.turkishairlines.com/de-de/miles-and-smiles/terms-and-conditions/privacy-notice-for-miles-and-smiles/index.html";
    if (/es/.test(lang)) return "https://www.turkishairlines.com/es-es/miles-and-smiles/terms-and-conditions/privacy-notice-for-miles-and-smiles/index.html";
    return "https://www.turkishairlines.com/en-us/miles-and-smiles/terms-and-conditions/privacy-notice-for-miles-and-smiles/index.html";
}

export const getMilesAndSmilesRegisterRightsGDPRLink2 = (i18n) => {
    let lang = i18n.language.toLowerCase();
    if (/tr/.test(lang)) return "https://www.turkishairlines.com/tr-tr/miles-and-smiles/kurallar-ve-kosullar/GDPR-privacy-notice-for-miles-and-smiles";
    if (/en/.test(lang)) return "https://www.turkishairlines.com/en-us/miles-and-smiles/terms-and-conditions/gdpr-privacy-notice-for-miles-and-smiles/index.html";
    if (/ru/.test(lang)) return "https://www.turkishairlines.com/ru-ru/miles-and-smiles/terms-and-conditions/gdpr-privacy-notice-for-miles-and-smiles/index.html";
    if (/fr/.test(lang)) return "https://www.turkishairlines.com/fr-fr/miles-and-smiles/terms-and-conditions/gdpr-privacy-notice-for-miles-and-smiles/index.html";
    if (/de/.test(lang)) return "https://www.turkishairlines.com/de-de/miles-and-smiles/terms-and-conditions/gdpr-privacy-notice-for-miles-and-smiles/index.html";
    if (/es/.test(lang)) return "https://www.turkishairlines.com/es-es/miles-and-smiles/terms-and-conditions/gdpr-privacy-notice-for-miles-and-smiles/index.html";
    return "https://www.turkishairlines.com/en-us/miles-and-smiles/terms-and-conditions/gdpr-privacy-notice-for-miles-and-smiles/index.html";
}